export default "__VITE_ASSET__OyN0ce$5__"